import { render } from "./floating-action-menu.vue?vue&type=template&id=dbadfb18&ts=true"
import script from "./floating-action-menu.vue?vue&type=script&lang=ts"
export * from "./floating-action-menu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__